import { ref, onMounted, onUnmounted, computed, type Ref } from 'vue'

export const useMobileBanner = (isLoggedIn: Ref<boolean>) => {
  const isMobile = ref(false)
  const isIOS = ref(false)
  const isBannerDismissed = ref(false)
  const localStorageKey = 'mobileBannerDismissed'

  const checkViewport = () => {
    isMobile.value = window.innerWidth < 768
    if (import.meta.client) {
      isIOS.value = /iPad|iPhone|iPod/.test(navigator.userAgent)
    }
  }

  const dismissBanner = () => {
    isBannerDismissed.value = true
    if (import.meta.client) {
      localStorage.setItem(localStorageKey, 'true')
    }
  }

  onMounted(() => {
    if (import.meta.client) {
      isBannerDismissed.value = localStorage.getItem(localStorageKey) === 'true'
      checkViewport()
      window.addEventListener('resize', checkViewport)
    }
  })

  onUnmounted(() => {
    if (import.meta.client) {
      window.removeEventListener('resize', checkViewport)
    }
  })

  const showBanner = computed(() => {
    if (import.meta.client) {
      return isLoggedIn.value && isMobile.value && !isBannerDismissed.value
    }
    return false
  })

  return {
    showBanner,
    dismissBanner,
    isIOS,
  }
}
